import React, { useEffect, useState } from "react";
import Modal from "react-awesome-modal";
import { Link } from "react-router-dom";
import useDelete from "../../Hooks/useDelete";  
import useUpdate from "../../Hooks/useUpdate";
import useValidateRole from "../../Hooks/useValidateRole";
import Table from "./../../Components/Table";
import Api from "../../Hooks/Api";
import Upload from "../../Hooks/Upload"
import Select from "react-select";
import { Progress } from "reactstrap"; 
import swal from "sweetalert";
const Applications = () => {
    const [open, setOpen] = useState(false);
    const [inputs, setInputs] = useState({});
    const [view, setView] = useState(false);
    const [viewDependants, setviewDependants] = useState(false);
    const [viewEmployer, setViewEmployer] = useState(false);
    const [viewPermits, setViewPermits] = useState(false);    
    const [viewActivities, setViewActivities] = useState(false);       
    const [viewDocuments, setViewDocuments] = useState(false); 
    const [viewTeam, setViewTeam] = useState(false);
    const [update, setUpdate] = useState(false);
    const [activeTab, setActiveTab] = useState('Applications');
    const [PageRole] = useState("Applications");  
    const [allDocuments,setAllDocuments] = useState([]);
    const [genderOptions, setGenderOptions] = useState([]);
    const [countryOptions, setCountryOptions] = useState([]);
    const [permitClassOptions, setPermitClassOptions] = useState([]);
    const [dependantTypeOptions, setDependantTypeOptions] = useState([]);
    const [RowData, setRowData] = useState([]);
    const [allEmployers,setAllEmployers] = useState([]);    
    const [allParties,setAllPermits] = useState([]);  
    const [alldependants,setAlldependants] = useState([]);   
    const [documentTypes, setdocumentTypes] = useState([]);  
    const [inputsDependants, setinputsDependants] = useState({});
    const [inputsPermit, setinputsPermit] = useState({});
    const [inputsEmployer, setinputsEmployer] = useState({}); 
    const [inputsTeam, setInputsTeam] = useState({});
    const [documents, setDocuments] = useState({});
    const url = "api/applicants";  

    const [selectedFile, setselectedFile] = useState("");
    const [loaded, setloaded] = useState("");
    const [message, setmessage] = useState("");

    
    const maxSelectFile = (event) => {
        let files = event.target.files; // create file object
        if (files.length > 1) {
          const msg = "Only One file can be uploaded at a time";
          event.target.value = null;
          setmessage(msg);
    
          return false;
        }
        return true;
      };
    const onChangeHandler = (event) => {
        //for multiple files
        var files = event.target.files;
        if (maxSelectFile(event)) {
          setselectedFile(files);
          setloaded(0);
        }
      };
      const onClickHandler = (event) => {
        event.preventDefault();
        if (selectedFile) {
          const data = new FormData();
          for (var x = 0; x < selectedFile.length; x++) {
            data.append("file", selectedFile[x]);
          }
          Upload.post("/api/upload/files", data, {
            // receive two parameter endpoint url ,form data
            onUploadProgress: (ProgressEvent) => {
              setloaded((ProgressEvent.loaded / ProgressEvent.total) * 100);
            },
          })
            .then((res) => {
              if (res.status == "200" && res.data.resultCode=="00") {
                setmessage("Uploaded successfully");
                setDocuments((documents) => ({ ...documents, path: res.data.data }));
              }else{
                setmessage("upload fail");
              }
            })
            .catch((err) => {
              setmessage("upload fail");
            });
        } else {
          setmessage("Select a file to upload");
        }
      };  
     const handleSelectDocumentsChange = (UserGroup, actionMeta) => {
        setDocuments((documents) => ({ ...documents, [actionMeta.name]: UserGroup.value }));
      }; 
      


    
    const fetchDependants = async (applicantId) => {
        try {
            Api.get("api/dependants/findByApplicantId?applicantId="+applicantId)
            .then(function (response) { 
              if (response.status=== 200) { 
                setAlldependants(response.data);                
              }
            })
            .catch(function (error) {
            })
            .then(function () {
              // always executed
            })           

            
        } catch (error) {
            console.error("Error fetching incidentTypes:", error);
        }
    };
    const fetchEmployers = async (applicantId) => {
        try {
            Api.get("api/employers/findByApplicantId?applicantId="+applicantId)
            .then(function (response) { 
              if (response.status=== 200) { 
                setAllEmployers(response.data);                
              }
            })
            .catch(function (error) {
            })
            .then(function () {
              // always executed
            })          

            
        } catch (error) {
            console.error("Error fetching Employers:", error);
        }
    };
    const fetchPermits = async (applicantId) => {
        try {
            Api.get("api/permits/findByApplicantId?applicantId="+applicantId)
            .then(function (response) { 
              if (response.status=== 200) { 
                setAllPermits(response.data);                
              }
            })
            .catch(function (error) {
            })
            .then(function () {
              // always executed
            })           

            
        } catch (error) {
            
        }
    };

    const fetchDocuments = async (applicantId) => {
        try {
            Api.get("api/documents/getByapplicantId?applicantId="+applicantId)
            .then(function (response) { 
              if (response.status=== 200) { 
                setAllDocuments(response.data);                
              }
            })
            .catch(function (error) {
            })
            .then(function () {
              // always executed
            })           

            
        } catch (error) {
        }
    };
 
   
    const fetchGender = async () => {
        try {
            Api.get("api/gender/getAll")
            .then(function (response) { 
              if (response.status=== 200) {
                const data =response.data;
                setGenderOptions(data);
              }
            })
            .catch(function (error) {
            })
            .then(function () {
              // always executed
            })           

            
        } catch (error) {
            console.error("Error fetching incidentTypes:", error);
        }
    };
    
    const fetchCountries = async () => {
        try {
            Api.get("api/countries/getAll")
            .then(function (response) { 
              if (response.status=== 200) {
                const data =response.data;
                setCountryOptions(data);
              }
            })
            .catch(function (error) {
            })
            .then(function () {
              // always executed
            })           

            
        } catch (error) {
            console.error("Error fetching incidentTypes:", error);
        }
    };
    const fetchPermitClass = async () => {
        try {
            Api.get("api/permitClasses/getAll")
            .then(function (response) { 
              if (response.status=== 200) {
                const data =response.data;
                setPermitClassOptions(data.permitClasses);
              }
            })
            .catch(function (error) {
            })
            .then(function () {
              // always executed
            })           

            
        } catch (error) {
            console.error("Error fetching incidentTypes:", error);
        }
    };
    const fetchDependantTypeOptions = async () => {
        try {
            Api.get("api/dependantsTypes/getAll")
            .then(function (response) { 
              if (response.status=== 200) {
                const data =response.data;
                setDependantTypeOptions(data.dependantsTypes);
              }
            })
            .catch(function (error) {
            })
            .then(function () {
              // always executed
            })           

            
        } catch (error) {
            console.error("Error fetching incidentTypes:", error);
        }
    };
    const fetchDocumentTypes = async () => {
        try {
            Api.get("api/docType/getAll?page=0&size=100")
            .then(function (response) { 
              if (response.status=== 200) {
                const data =response.data;
                data.docType.forEach((k) => {
                        let col = {
                            value: k.id,
                            label: k.name,
                        };
                        setdocumentTypes((documentTypes) => [ ...documentTypes, col ]);
                });
              }
            })
            .catch(function (error) {
            })
            .then(function () {
              // always executed
            })           

            
        } catch (error) {
            console.error("Error fetching incidentTypes:", error);
        }
    };
    const MoreActions = (props) => {
        return (
          <span>
            <a
              class="btn btn-secondary btn-sm dropdown-toggle"
              href="#"
              role="button"
              id="dropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              More Actions&nbsp;&nbsp;
              <i class="fa fa-caret-down" aria-hidden="true"></i>
            </a>
    
            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
              <a
                style={{ cursor: "pointer" }}
                class="dropdown-item "
                onClick={(e) => handleView(props.selecteditem, e)}
              >
                View
              </a>
    
              <a
                style={{ cursor: "pointer" }}
                class="dropdown-item "
                onClick={(e) => handleEdit(props.selecteditem, e)}
              >
                Edit
              </a>
    
              <a
                style={{ cursor: "pointer" }}
                class="dropdown-item "
                onClick={(e) => HandleDelete(props.selecteditem, e)}
              >
                Delete
              </a>   
    
            </div>
          </span>
        );
      };
    const setApplicationsdata = async (data) => {       
        const rows = data?.applicants || [];                 
                
                rows.forEach((k) => {
                    const Rowdata = { 
                        id:k.id,
                        fullName: k.fullName,
                        country: k.country?k.country.name:"",
                        telNo: k.telNo,     
                        email: k.email,
                        passportNumber: k.passportNumber,
                        dob: k.dob,                 
                        Actions: <MoreActions selecteditem={k} />,
                    }; 
                    setRowData((inputs) => [ ...inputs, Rowdata ]);
                        
                });
            
    }
    const FetchAll = async () => { 
        setRowData([]);
        try {
            Api.get("api/applicants/getAll?page=0&size=10")
            .then(function (response) { 
              if (response.status=== 200) {
                const data =response.data;
                setApplicationsdata(data); 
                const totalPages = data.totalPages;   
                for (let i = 0; i < totalPages; i++) {  
                    let nextPage=parseFloat(i) + parseFloat(1) ;       
                    Api.get("api/applicants/getAll?page="+nextPage+"&size=10")
                    .then(function (response) {                        
                      if (response.status=== 200) {
                        const data =response.data;
                        setApplicationsdata(data); 
                      }
                    })
                    .catch(function (error) {
                    })
                    .then(function () {
                      // always executed
                    }) 
                }
              }
            })
            .catch(function (error) {
            })
            .then(function () {
              // always executed
            })       

            
        } catch (error) { 
        }
    }; 
    useEffect(() => {
        FetchAll();    
        fetchCountries();
        fetchPermitClass();
        fetchDependantTypeOptions();
        fetchGender();
        fetchDocumentTypes();  
    }, []);  
  
   

    const handleOpenModal = () => {
        const currentUserName = window.sessionStorage.getItem("UserName");
        setInputs({ createdBy: currentUserName });
        setOpen(true);
    };

    const handleInputChange = (event) => {
        event.persist();
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        setInputs((inputs) => ({ ...inputs, [name]: value }));
    };
    const handlePermitInputChange = (event) => {
        event.persist();
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        setinputsPermit((inputs) => ({ ...inputs, [name]: value }));
    };
    const handleEmployerInputChange= (event) => {
        event.persist();
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        setinputsEmployer((inputs) => ({ ...inputs, [name]: value }));
    };
    const handleDependantsInputChange = (event) => {
        event.persist();
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        setinputsDependants((inputs) => ({ ...inputs, [name]: value }));
    };
    const handleEdit = (k) => {
        setInputs(k)
        if (k.id) {
            setOpen(true);
            setUpdate(true);
            setView(false);
        } else {
            alert("Select a record to edit");
        }
    };

    const handleView = (k) => {
        setInputs(k);      
        setInputsTeam((inputsTeam) => ({ ...inputsTeam, ["applicantId"]:k.id}));
        setDocuments((documents) => ({ ...documents,["applicantId"]: k.id }));
        setinputsDependants((inputsDependants) => ({ ...inputsDependants,["applicantId"]: k.id }));
        setinputsPermit((inputsPermit) => ({ ...inputsPermit,["applicantId"]: k.id }));
        setinputsEmployer((inputsEmployer) => ({ ...inputsEmployer,["applicantId"]: k.id }));
        if (k.id) {         
            fetchDocuments(k.id);          
            fetchDependants(k.id)
            fetchEmployers(k.id)
            fetchPermits(k.id)
            setViewTeam(true);
            setViewActivities(true)
            setViewDocuments(true)
            setviewDependants(true)
            setViewEmployer(true)
            setViewPermits(true)
            setView(true);
            setUpdate(false);
            setOpen(true);
        } else {
            alert("Select a record to view");
        }
    };    
    const handleCloseModal = () => {
        setInputs({});
        setOpen(false);
        setView(false);
        setUpdate(false);
    };   

    const HandleUpdate = (inputs,url) => {
        useUpdate(url+"/update" , inputs);
        setTimeout(function () {
            FetchAll();
        }, 4000);
        
    };
    const HandleSubmitDocuments = (event) => {
        event.preventDefault(); 
        if(!documents.applicantId || documents.applicantId == "undefined"){
            alert("Add or select campaign first")
            return;
        } 
        if (update) {
            HandleUpdate(documents,"api/documents");
        } else {
            HandleSave(documents,"api/documents","Documents");
        }
        setTimeout(function () {
            fetchDocuments(inputs.id)
        }, 4000);
        
    };
    const handleSubmitEmployers= (event) => {
        event.preventDefault(); 
        if(!inputsEmployer.applicantId || inputsEmployer.applicantId == "undefined"){
            alert("Add or select Applicant first")
            return;
        } 
        if (update) {
            HandleUpdate(inputsEmployer,"api/employers");
        } else {
            HandleSave(inputsEmployer,"api/employers","employers");
        }
        setTimeout(function () {
            fetchEmployers(inputs.id)
        }, 4000);
        
    };
    const handleSubmitDependants= (event) => {
        event.preventDefault(); 
        if(!inputsDependants.applicantId || inputsDependants.applicantId == "undefined"){
            alert("Add or select Applicant first")
            return;
        } 
        if (update) {
            HandleUpdate(inputsDependants,"api/dependants");
        } else {
            HandleSave(inputsDependants,"api/dependants","dependant");
        }
        setTimeout(function () {
            fetchDependants(inputs.id)
        }, 4000);
       
    };
    const handleSubmitPermit= (event) => {
        event.preventDefault(); 
        if(!inputsPermit.applicantId || inputsPermit.applicantId == "undefined"){
            alert("Add or select Applications first")
            return;
        } 
        if (update) {
            HandleUpdate(inputsPermit,"api/permits");
        } else {
            HandleSave(inputsPermit,"api/permits","Team");
        }
        setTimeout(function () {
            fetchPermits(inputs.id)
        }, 4000);
        
    };  
    const handleDocumentsInputChange= (event) => {
        event.persist();
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        setDocuments((documents) => ({ ...documents, [name]: value }));
    };
    const useSave = (url = ``, inputs = {},menu=``, config = {}) => {        
        let data;
        let headers;    
        if (inputs instanceof FormData) {
          data = inputs;
          headers = { ...config.headers }; // Don't set Content-Type header, let the browser set it
        } else {
          data = JSON.stringify(inputs);
          headers = { 'Content-Type': 'application/json', ...config.headers };
        }      
        Api.post(url, data, { headers })
          .then((response) => {
            if (response.data.resultCode === "00") {
              if(menu==="Applications"){
                  var result = JSON.parse(response.data.data);                   
                    setInputsTeam((inputsTeam) => ({ ...inputsTeam, ["applicantId"]:result.id}));
                    setDocuments((documents) => ({ ...documents,["applicantId"]: result.id }));
                    setinputsDependants((inputsDependants) => ({ ...inputsDependants,["applicantId"]: result.id }));
                    setinputsPermit((inputsPermit) => ({ ...inputsPermit,["applicantId"]: result.id }));
                    setinputsEmployer((inputsEmployer) => ({ ...inputsEmployer,["applicantId"]: result.id }));

              }
             
              swal("", "saved", "success"); 
            } else {
              swal("", response.data.description, "error"); 
            }
          })
          .catch((error) => {
            swal("", "Failed", "error"); 
          });
      
    };
    const HandleSave = (inputs,url,menu) => {
        useSave(url+"/create", inputs,menu);
        setTimeout(function () {
            FetchAll();
        }, 4000);
        
    };
    const handleSubmit = async (event) => {
        event.preventDefault();
        if (update) {
            HandleUpdate(inputs,url);
        } else {
            HandleSave(inputs,url,"Applications");
        }        
    }; 
    const CallDeleteHook = (id) => {
        useDelete(url + "/delete?id=" + id);        
        setTimeout(function () {
            FetchAll();
        }, 4000);
    };
    const HandleDelete = (k) => {
        if (k.id) {
            CallDeleteHook(k.id);
        } else {
            alert("Select a record to delete");
        }
    }; 

    const columns = [

        { label: "Name", field: "fullName", sort: "asc" },
        { label: "Country", field: "country", sort: "asc" },
        { label: "Tel No", field: "telNo", sort: "asc" },
        { label: "Email", field: "email", sort: "asc" },
        { label: "Passport Number", field: "passportNumber", sort: "asc" },
        { label: "DOB", field: "dob", sort: "asc" },
        { label: "Actions", field: "Actions", sort: "asc" },

    ];  

    const ActionsBtn = () => (
        <div>
            {useValidateRole(PageRole, "Edit") && (
                <button className="btn btn-primary p-2" type="button" onClick={handleEdit}>
                    Update
                </button>
            )}
            &nbsp; &nbsp;
            {useValidateRole(PageRole, "Remove") && (
                <button onClick={HandleDelete} className="btn btn-danger p-2">
                    Delete
                </button>
            )}
            &nbsp;
            <button className="btn btn-warning p-2" type="button" onClick={handleCloseModal}>
                Close
            </button>
        </div>
    );



    return (
        <div id="content" className="content">
            <ol className="breadcrumb float-xl-right">
                <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">Applications</li>
            </ol>
            <h1 className="page-header mb-3">Applications</h1>
            <div style={{ backgroundColor: "white" }}>
                <div className="row">
                    <div className="col-sm-12 d-flex flex-row float-right">
                        &nbsp; &nbsp; &nbsp;
                        {useValidateRole(PageRole, "AddNew") && (
                            <button
                                onClick={handleOpenModal}
                                className="btn btn-primary p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; New Applications&nbsp;
                            </button>
                        )}                        
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <Table Rows={RowData} columns={columns} />
                    </div>
                </div>
            </div>

            <Modal visible={open} width="80%" height="80%" effect="fadeInUp">
                <div style={{ overflowY: "auto", height: "100%" }}>
                    <a className="close" onClick={handleCloseModal}>
                        &times;
                    </a> 
                    <div className="container-fluid">
                        <div className="col-sm-12">
                            <div className="ibox-content">
                                <br />
                              
                                    <div>
                                        <ul className="nav nav-tabs" id="myTab" role="tablist">     
                                            <li className="nav-item" style={{cursor: "pointer"}}>
                                                <a className={`nav-link ${activeTab === 'Applications' ? 'active' : ''}`} id="Applications-tab" onClick={() => setActiveTab('Applications')} role="tab" aria-selected={activeTab === 'Applications'}>Applications</a>
                                            </li>
                                            <li className="nav-item" style={{cursor: "pointer"}}>
                                                <a className={`nav-link ${activeTab === 'dependants' ? 'active' : ''}`} id="dependants-tab" onClick={() => setActiveTab('dependants')} role="tab" aria-selected={activeTab === 'dependants'}>Dependants</a>
                                            </li>
                                            <li className="nav-item" style={{cursor: "pointer"}}>
                                                <a className={`nav-link ${activeTab === 'employers' ? 'active' : ''}`} id="employers-tab" onClick={() => setActiveTab('employers')} role="tab" aria-selected={activeTab === 'employers'}>Employers</a>
                                            </li>
                                            <li className="nav-item" style={{cursor: "pointer"}}>
                                                <a className={`nav-link ${activeTab === 'permits' ? 'active' : ''}`} id="permits-tab" onClick={() => setActiveTab('permits')} role="tab" aria-selected={activeTab === 'permits'}>Permits</a>
                                            </li>
                                            {/* 
                                            <li className="nav-item" style={{cursor: "pointer"}}>
                                                <a className={`nav-link ${activeTab === 'documents' ? 'active' : ''}`} id="documents-tab" onClick={() => setActiveTab('documents')} role="tab" aria-selected={activeTab === 'documents'}>Documents</a>
                                            </li>                                                     */}
                                        </ul>
                                        <div className="tab-content" id="myTabContent">
                                            <div className={`tab-pane fade ${activeTab === 'Applications' ? 'show active' : ''}`} id="Applications-tab-pane" role="tabpanel" aria-labelledby="Applications-tab">
                                            {view ? (
                                             <div>
                                                <h3>Applications</h3>
                                                <table className="table table-sm">
                                                    <tbody>
                                                        <tr>
                                                            <td className="font-weight-bold">Name:</td>
                                                            <td>{inputs.fullName}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="font-weight-bold">Passport Number:</td>
                                                            <td>{inputs.passportNumber}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="font-weight-bold">Tel No:</td>
                                                            <td>{inputs.telNo}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="font-weight-bold">Email:</td>
                                                            <td>{inputs.email}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="font-weight-bold">Gender:</td>
                                                            <td>{inputs.gender.name}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="font-weight-bold">Country:</td>
                                                            <td>{inputs.country.name}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="font-weight-bold">Places Of Birth:</td>
                                                            <td>{inputs.placesOfBirth}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="font-weight-bold">Physical Address:</td>
                                                            <td>{inputs.physicalAddress}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="font-weight-bold">DOB:</td>
                                                            <td>{inputs.dob}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <br />
                                                <div
                                                    style={{ display: "flex", "justify-content": "flex-end" }}
                                                >
                                                    <ActionsBtn />
                                                </div> 
                                                 </div>
                                            ) : (
                                                <form className="form-horizontal" onSubmit={handleSubmit}>                                                
                                                    <div className="tab-content" id="myTabContent">
                                                        <div className={`tab-pane fade ${activeTab === 'Applications' ? 'show active' : ''}`} id="Applications-tab-pane" role="tabpanel" aria-labelledby="Applications-tab">
                                                            <h3>Applications</h3>
                                                            <form className="form-horizontal" onSubmit={handleSubmit}>  
                                                            <div className="row">
                                                                <div className="col-sm">
                                                                    <div className="form-group">
                                                                        <label htmlFor="fullName" className="font-weight-bold">Full Name</label>
                                                                        <input type="text" className="form-control" name="fullName" required value={inputs.fullName || ""} onChange={(e) => handleInputChange(e)} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-sm">
                                                                    <div className="form-group">
                                                                        <label htmlFor="telNo" className="font-weight-bold">Mobile Number</label>
                                                                        <input type="text" className="form-control" name="telNo" required value={inputs.telNo || ""} onChange={(e) => handleInputChange(e)} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                            <div className="col-sm">
                                                                <div className="form-group">
                                                                    <label htmlFor="countryId" className="font-weight-bold">Country</label>
                                                                    <select className="form-control" name="countryId" required value={inputs.countryId || ""} onChange={(e) => handleInputChange(e)}>
                                                                        <option value="">Select Country</option>
                                                                        {countryOptions && countryOptions.map((country) => (
                                                                            <option key={country.countryId} value={country.countryId}>
                                                                                {country.name}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm">
                                                                <div className="form-group">
                                                                    <label htmlFor="genderId" className="font-weight-bold">Gender</label>
                                                                    <select className="form-control" name="genderId" required value={inputs.genderId || ""} onChange={(e) => handleInputChange(e)}>
                                                                        <option value="">Select Gender</option>                                                                        
                                                                        {genderOptions && genderOptions.map((country) => (
                                                                            <option key={country.genderId} value={country.genderId}>
                                                                                {country.name}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-sm">
                                                                    <div className="form-group">
                                                                        <label htmlFor="email" className="font-weight-bold">Email</label>
                                                                        <input type="email" className="form-control" name="email" required value={inputs.email || ""} onChange={(e) => handleInputChange(e)} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-sm">
                                                                    <div className="form-group">
                                                                        <label htmlFor="physicalAddress" className="font-weight-bold">physicalAddress</label>
                                                                        <input type="text" className="form-control" name="physicalAddress" required value={inputs.physicalAddress || ""} onChange={(e) => handleInputChange(e)} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-sm">
                                                                    <div className="form-group">
                                                                        <label htmlFor="dob" className="font-weight-bold">DOB</label>
                                                                        <input type="date" className="form-control" name="dob" required value={inputs.dob || ""} onChange={(e) => handleInputChange(e)} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-sm">
                                                                    <div className="form-group">
                                                                        <label htmlFor="placesOfBirth" className="font-weight-bold">Place Of Birth</label>
                                                                        <input type="text" className="form-control" name="placesOfBirth" required value={inputs.placesOfBirth || ""} onChange={(e) => handleInputChange(e)} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-sm-6">
                                                                    <div className="form-group">
                                                                        <label htmlFor="passportNumber" className="font-weight-bold">Passport Number</label>
                                                                        <input type="textl" className="form-control" name="passportNumber" required value={inputs.passportNumber || ""} onChange={(e) => handleInputChange(e)} />
                                                                    </div>
                                                                </div> 
                                                            </div>
                                                            </form>
                                                        </div>                                                    
                                                    
                                                    </div>
                                                    <div
                                                     style={{
                                                         display: "flex",
                                                         justifyContent: "flex-end",
                                                     }}
                                                 >
                                                     <div className="d-flex flex-row">
                                                         {update ? (
                                                             <button className="btn btn-primary p-2" type="submit">
                                                                 Update
                                                             </button>
                                                         ) : (
                                                             <button className="btn btn-primary p-2" type="submit">
                                                                 Submit
                                                             </button>
                                                         )}
                                                         &nbsp;
                                                         <button
                                                             className="btn btn-warning p-2"
                                                             type="button"
                                                             onClick={handleCloseModal}
                                                         >
                                                             Close
                                                         </button>
                                                     </div>
                                                     <br />
                                                 </div> 
                                                </form>
                                            )}

                                            </div>
                                            <div className={`tab-pane fade ${activeTab === 'dependants' ? 'show active' : ''}`} id="areas-tab-pane" role="tabpanel" aria-labelledby="dependants-tab">
                                                
                                                {viewDependants ? (
                                                    <div>
                                                         <button className="btn-primary" onClick={()=>{setviewDependants(false)}}>Add Dependant</button>
                                                    <table className="table table-sm">
                                                    <thead>
                                                        <tr>
                                                            <th>Name</th>
                                                            <th>Dependants Type</th>
                                                            <th>Country</th>
                                                            <th>Gender</th>
                                                            <th>tel No</th>
                                                            <th>email</th>
                                                            <th>passportNumber</th>
                                                            <th>DOB</th>
                                                            <th>Place Of Birth</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {alldependants.map(area => (
                                                            <tr key={area.id}>
                                                                <td>{area.fullName}</td>
                                                                <td>{area.dependantsType.name}</td>
                                                                <td>{area.country.name}</td>
                                                                <td>{area.gender.name}</td>
                                                                <td>{area.telNo}</td>
                                                                <td>{area.passportNumber}</td>
                                                                <td>{area.dob}</td>
                                                                <td>{area.placesOfBirth}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                                </div>):(
                                                      <form className="form-horizontal" onSubmit={handleSubmitDependants}>
                                                         <button className="btn-warning" onClick={()=>{setviewDependants(true)}}>Back</button>
                                                            <div className="row">
                                                                <div className="col-sm">
                                                                    <div className="form-group">
                                                                        <label htmlFor="fullName" className="font-weight-bold">Full Name</label>
                                                                        <input type="text" className="form-control" name="fullName" required value={inputsDependants.fullName || ""} onChange={(e) => handleDependantsInputChange(e)} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-sm">
                                                                    <div className="form-group">
                                                                        <label htmlFor="telNo" className="font-weight-bold">Mobile Number</label>
                                                                        <input type="text" className="form-control" name="telNo" required value={inputsDependants.telNo || ""} onChange={(e) => handleDependantsInputChange(e)} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-sm">
                                                                    <div className="form-group">
                                                                        <label htmlFor="passportNumber" className="font-weight-bold">Passport Number</label>
                                                                        <input type="textl" className="form-control" name="passportNumber" required value={inputsDependants.passportNumber || ""} onChange={(e) => handleDependantsInputChange(e)} />
                                                                    </div>
                                                                </div> 
                                                                <div className="col-sm">
                                                                <div className="form-group">
                                                                    <label htmlFor="countryId" className="font-weight-bold">Type</label>
                                                                    <select className="form-control" name="dependantTypeId" required value={inputsDependants.dependantTypeId || ""} onChange={(e) => handleDependantsInputChange(e)}>
                                                                        <option value="">Select Type</option>
                                                                        {dependantTypeOptions && dependantTypeOptions.map((country) => (
                                                                            <option key={country.id} value={country.id}>
                                                                                {country.name}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            </div>
                                                            <div className="row">
                                                            <div className="col-sm">
                                                                <div className="form-group">
                                                                    <label htmlFor="countryId" className="font-weight-bold">Country</label>
                                                                    <select className="form-control" name="countryId" required value={inputsDependants.countryId || ""} onChange={(e) => handleDependantsInputChange(e)}>
                                                                        <option value="">Select Country</option>
                                                                        {countryOptions && countryOptions.map((country) => (
                                                                            <option key={country.countryId} value={country.countryId}>
                                                                                {country.name}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm">
                                                                <div className="form-group">
                                                                    <label htmlFor="genderId" className="font-weight-bold">Gender</label>
                                                                    <select className="form-control" name="genderId" required value={inputsDependants.genderId || ""} onChange={(e) => handleDependantsInputChange(e)}>
                                                                        <option value="">Select Gender</option>                                                                        
                                                                        {genderOptions && genderOptions.map((country) => (
                                                                            <option key={country.genderId} value={country.genderId}>
                                                                                {country.name}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-sm">
                                                                    <div className="form-group">
                                                                        <label htmlFor="email" className="font-weight-bold">Email</label>
                                                                        <input type="email" className="form-control" name="email" required value={inputsDependants.email || ""} onChange={(e) => handleDependantsInputChange(e)} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-sm">
                                                                    <div className="form-group">
                                                                        <label htmlFor="physicalAddress" className="font-weight-bold">physicalAddress</label>
                                                                        <input type="text" className="form-control" name="physicalAddress" required value={inputsDependants.physicalAddress || ""} onChange={(e) => handleDependantsInputChange(e)} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-sm">
                                                                    <div className="form-group">
                                                                        <label htmlFor="dob" className="font-weight-bold">DOB</label>
                                                                        <input type="date" className="form-control" name="dob" required value={inputsDependants.dob || ""} onChange={(e) => handleDependantsInputChange(e)} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-sm">
                                                                    <div className="form-group">
                                                                        <label htmlFor="placesOfBirth" className="font-weight-bold">Place Of Birth</label>
                                                                        <input type="text" className="form-control" name="placesOfBirth" required value={inputsDependants.placesOfBirth || ""} onChange={(e) => handleDependantsInputChange(e)} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                           
                                                            
                                                     <div
                                                     style={{
                                                         display: "flex",
                                                         justifyContent: "flex-end",
                                                     }}
                                                 >
                                                     <div className="d-flex flex-row">
                                                         {update ? (
                                                             <button className="btn btn-primary p-2" type="submit">
                                                                 Update
                                                             </button>
                                                         ) : (
                                                             <button className="btn btn-primary p-2" type="submit">
                                                                 Submit
                                                             </button>
                                                         )}
                                                         &nbsp;
                                                         <button
                                                             className="btn btn-warning p-2"
                                                             type="button"
                                                             onClick={handleCloseModal}
                                                         >
                                                             Close
                                                         </button>
                                                     </div>
                                                     <br />
                                                 </div>
                                            </form>)}
                                            </div>

                                            <div className={`tab-pane fade ${activeTab === 'employers' ? 'show active' : ''}`} id="employers-tab-pane" role="tabpanel" aria-labelledby="employers-tab">
                                                
                                                {viewEmployer ?(
                                                    <div>
                                                         <button className="btn-primary" onClick={()=>{setViewEmployer(false)}}>Add employer</button>
                                                     <table className="table table-sm">
                                                     <thead>
                                                         <tr>
                                                             <th>Name</th>
                                                             <th>Address</th>
                                                             <th>Tel No</th>
                                                             <th>Email</th> 
                                                         </tr>
                                                     </thead>
                                                     <tbody>
                                                         {allEmployers.map(points => (
                                                             <tr key={points.id}>
                                                                 <td>{points.name}</td>
                                                                 <td>{points.address}</td>
                                                                 <td>{points.email}</td>
                                                                 <td>{points.telNo}</td> 
                                                             </tr>
                                                         ))}
                                                     </tbody>
                                                 </table>
                                                 </div>
                                                ):(
                                                    <form className="form-horizontal" onSubmit={handleSubmitEmployers}>
                                                         <button className="btn-warning" onClick={()=>{setViewEmployer(true)}}>Back</button>
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <div className="form-group">
                                                            <label htmlFor="focalPointName" className="font-weight-bold">Name</label>
                                                            <input type="text" className="form-control" name="name" required value={inputsEmployer.name || ""} onChange={(e) => handleEmployerInputChange(e)} />
                                                        </div> 
                                                    </div>
                                                    <div className="col-sm">
                                                        <div className="form-group">
                                                            <label htmlFor="address" className="font-weight-bold">Address</label>
                                                            <input type="text" className="form-control" name="address" required value={inputsEmployer.address || ""} onChange={(e) => handleEmployerInputChange(e)} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm">
                                                        <div className="form-group">
                                                            <label htmlFor="focalPointName" className="font-weight-bold">Email</label>
                                                            <input type="email" className="form-control" name="email" required value={inputsEmployer.email || ""} onChange={(e) => handleEmployerInputChange(e)} />
                                                        </div> 
                                                    </div>
                                                    <div className="col-sm">
                                                        <div className="form-group">
                                                            <label htmlFor="telNo" className="font-weight-bold">Tel No</label>
                                                            <input type="text" className="form-control" name="telNo" required value={inputsEmployer.telNo || ""} onChange={(e) => handleEmployerInputChange(e)} />
                                                        </div>
                                                    </div>
                                                </div>
                                                 <div
                                                 style={{
                                                     display: "flex",
                                                     justifyContent: "flex-end",
                                                 }}
                                             >
                                                 <div className="d-flex flex-row">
                                                     {update ? (
                                                         <button className="btn btn-primary p-2" type="submit">
                                                             Update
                                                         </button>
                                                     ) : (
                                                         <button className="btn btn-primary p-2" type="submit">
                                                             Submit
                                                         </button>
                                                     )}
                                                     &nbsp;
                                                     <button
                                                         className="btn btn-warning p-2"
                                                         type="button"
                                                         onClick={handleCloseModal}
                                                     >
                                                         Close
                                                     </button>
                                                 </div>
                                                 <br />
                                             </div>
                                            </form>)}
                                            </div>
                                            <div className={`tab-pane fade ${activeTab === 'permits' ? 'show active' : ''}`} id="permits-tab-pane" role="tabpanel" aria-labelledby="permits-tab">
                                                
                                                {viewPermits ?( 
                                                    <div>
                                                    <button className="btn-primary" onClick={()=>{setViewPermits(false)}}>Add Permit</button>
                                                    <table className="table table-sm">
                                                    <thead>
                                                        <tr>
                                                          
                                                            <th>Permit Class</th>
                                                            <th>Status</th>
                                                            <th>Duration</th>
                                                            <th>Date Of Approval</th>
                                                            <th>Approved By</th>
                                                            <th>Remarks</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {allParties.map(parties => (
                                                            <tr key={parties.id}>
                                                                <td>{parties.permitClass.name}</td>
                                                                <td>{parties.status}</td>
                                                                <td>{parties.duration}</td>
                                                                <td>{parties.dateOfApproval}</td>
                                                                <td>{parties.approvedBy}</td>
                                                                <td>{parties.remarks}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                                </div>)   :(
                                                        <form className="form-horizontal" onSubmit={handleSubmitPermit}>
                                                            <button className="btn-warning" onClick={()=>{setViewPermits(true)}}>Back</button>
                                                        <div className="row">
                                                            <div className="col-sm">
                                                                <div className="form-group">
                                                                    <label htmlFor="partyName" className="font-weight-bold">Status</label>
                                                                    <input type="text" className="form-control" name="status" required value={inputsPermit.status || ""} onChange={(e) => handlePermitInputChange(e)} />
                                                                </div>                                                                 
                                                            </div>                                                           
                                                            <div className="col-sm">
                                                                <div className="form-group">
                                                                    <label htmlFor="countryId" className="font-weight-bold">Permit Class</label>
                                                                    <select className="form-control" name="permitClassId" required value={inputsPermit.permitClassId || ""} onChange={(e) => handlePermitInputChange(e)}>
                                                                        <option value="">Select Permit class</option>
                                                                        {permitClassOptions && permitClassOptions.map((permit) => (
                                                                            <option key={permit.id} value={permit.id}>
                                                                                {permit.name}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            </div>
                                                            <div className="row">                                                             
                                                            <div className="col-sm">                                                                 
                                                                <div className="form-group">
                                                                    <label htmlFor="partyDescription" className="font-weight-bold">Duration</label>
                                                                    <input type="text" className="form-control" name="duration" required value={inputsPermit.duration || ""} onChange={(e) => handlePermitInputChange(e)} />
                                                                </div>
                                                             </div>
                                                                <div className="col-sm">                                                                 
                                                                <div className="form-group">
                                                                    <label htmlFor="partyDescription" className="font-weight-bold">Date Of Approval</label>
                                                                    <input type="date" className="form-control" name="dateOfApproval" required value={inputsPermit.dateOfApproval || ""} onChange={(e) => handlePermitInputChange(e)} />
                                                                </div>
                                                                </div>
                                                         </div>
                                                         <div className="row">                                                             
                                                            <div className="col-sm">                                                                 
                                                                <div className="form-group">
                                                                    <label htmlFor="approvedBy" className="font-weight-bold">Approved By</label>
                                                                    <input type="text" className="form-control" name="approvedBy" required value={inputsPermit.approvedBy || ""} onChange={(e) => handlePermitInputChange(e)} />
                                                                </div>
                                                             </div>
                                                                <div className="col-sm">                                                                 
                                                                <div className="form-group">
                                                                    <label htmlFor="remarks" className="font-weight-bold">remarks</label>
                                                                    <input type="text" className="form-control" name="remarks" required value={inputsPermit.remarks || ""} onChange={(e) => handlePermitInputChange(e)} />
                                                                </div>
                                                                </div>
                                                         </div>
                                                        <div
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "flex-end",
                                                                    }}
                                                                >
                                                                    <div className="d-flex flex-row">
                                                                        {update ? (
                                                                            <button className="btn btn-primary p-2" type="submit">
                                                                                Update
                                                                            </button>
                                                                        ) : (
                                                                            <button className="btn btn-primary p-2" type="submit">
                                                                                Submit
                                                                            </button>
                                                                        )}
                                                                        &nbsp;
                                                                        <button
                                                                            className="btn btn-warning p-2"
                                                                            type="button"
                                                                            onClick={handleCloseModal}
                                                                        >
                                                                            Close
                                                                        </button>
                                                                    </div>
                                                                    <br />
                                                                </div>
                                                    </form>)}
                                            </div>   
                                             
                                                      
                                                        <div className={`tab-pane fade ${activeTab === 'documents' ? 'show active' : ''}`} id="documents-tab-pane" role="tabpanel" aria-labelledby="documents-tab">
                                                        
                                                        {viewDocuments ? (
                                                            <div>
                                                                <button className="btn-primary" onClick={()=>{setViewDocuments(false)}}>Add Document</button>
                                                                <br/>
                                                                    <table className="table table-sm">
                                                                        <tr>
                                                                        <th>id</th>
                                                                        <th>Type</th>
                                                                            <th>Name</th>
                                                                            <th>Description </th> 
                                                                            <th>View </th>
                                                                        </tr>
                                                                    <tbody>
                                                                    

                                                                    {allDocuments.map(d => ( 
                                                                        <tr key={d.id}>
                                                                            <td>{d.id}</td>
                                                                            <td>{d.docType.name}</td>
                                                                            <td>{d.name}</td>
                                                                            <td>{d.description}</td> 
                                                                            <td><a href={ process.env.REACT_APP_BASE_URL +"api/upload/files/"+d.path} target="_blank"> View </a></td>
                                                                            
                                                                        </tr>
                                                                    ))} 
                                                                        
                                                                        
                                                                    </tbody>
                                                                </table>
                                                                <br />
                                                                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                                                    <ActionsBtn />
                                                                </div>
                                                                <br />
                                                            </div>
                                                        ) : (
                                                            <form className="form-horizontal" onSubmit={HandleSubmitDocuments}>
                                                                <button className="btn-warning" onClick={()=>{setViewDocuments(true)}}>Back</button>
                                                                <div className="row"> 
                                                                    <div className="col-sm-6">
                                                                        <div className="form-group">
                                                                            <label htmlFor="name" className="font-weight-bold">
                                                                            Document Name
                                                                            </label>
                                                                            <input
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="name"
                                                                                required
                                                                                value={documents.name || ""}
                                                                                onChange={handleDocumentsInputChange}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-sm-6">
                                                                        <div className="form-group">
                                                                            <label htmlFor="name" className="font-weight-bold">
                                                                            Document Type
                                                                            </label>
                                                                            <Select
                                                                        name="typeId"
                                                                        value={documentTypes.filter(
                                                                        (option) =>
                                                                        option.value ===
                                                                        documents.typeId
                                                                    )}
                                                                    onChange={
                                                                        handleSelectDocumentsChange
                                                                    }
                                                                    options={documentTypes}
                                                                    />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                        
                                                            
                                                                <div className="row">
                                                                <div className="col-sm">
                                                                        <div className="form-group">
                                                                            <label htmlFor="description" className="font-weight-bold">
                                                                            Description
                                                                            </label>
                                                                            <textarea
                                                                                type="text"
                                                                                className="form-control"
                                                                                name="description"
                                                                                required
                                                                                value={documents.description || ""}
                                                                                onChange={handleDocumentsInputChange}
                                                                            />
                                                                        </div>
                                                                    </div>                                    
                                                                </div>
                                                                <div className="row">
                                                                <div className="col-sm-12">
                                                                    <input
                                                                        type="file"
                                                                        className="form-control"
                                                                        name="file"
                                                                        onChange={onChangeHandler}
                                                                        accept=".xlsx, .xls, .csv"
                                                                    />
                                                                    </div>
                                                                    <br/>
                                                                    <div className="col-sm-12">
                                                                        <Progress
                                                                        max="100"
                                                                        color="success"
                                                                        value={loaded}
                                                                        >
                                                                        {Math.round(loaded, 2)}%
                                                                        </Progress>
                                                                        <button
                                                                        type="button"
                                                                        class="btn btn-success "
                                                                        onClick={onClickHandler}
                                                                        >
                                                                        Upload
                                                                        </button>
                                                                    </div>
                                                                    <p>{message}</p>
                                                                </div>
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "flex-end",
                                                                    }}
                                                                >
                                                                    <div className="d-flex flex-row">
                                                                        {update ? (
                                                                            <button className="btn btn-primary p-2" type="submit">
                                                                                Update
                                                                            </button>
                                                                        ) : (
                                                                            <button className="btn btn-primary p-2" type="submit">
                                                                                Submit
                                                                            </button>
                                                                        )}
                                                                        &nbsp;
                                                                        <button
                                                                            className="btn btn-warning p-2"
                                                                            type="button"
                                                                            onClick={handleCloseModal}
                                                                        >
                                                                            Close
                                                                        </button>
                                                                    </div>
                                                                    <br />
                                                                </div>
                                                            </form>
                                                        )}
                                                        </div>
                                        </div>

                                        <br />
                                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                            {/* <ActionsBtn /> */}
                                        </div>
                                        <br />
                                    </div>
                               
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default Applications;
